<template>
  
  <div class="marginBT">
    <div class="marginLR center titlesContainer">
      <h2 class="titles">
        {{ $t("datos.datosDeudorTitulo") }}
        {{
          isDebtor ? $t("datos.textos.reclamada") : $t("datos.textos.acreedora")
        }}
      </h2>
      <p class="subtitles">
        {{ $t("datos.datosDeudorSubtitulo") }}
        {{
          isDebtor
            ? $t("datos.textos.reclamaDeuda")
            : $t("datos.textos.debeDeuda")
        }}
      </p>
    </div>

    <div class="whitePanel marginBottom">
      <a  href="#" class="btn-flotante" @click="radomUser()" v-if="local"><em class="pi pi-user-plus" /></a>
      <Errors
        v-if="this.errors && this.errors.length > 0"
        :errors="this.errors"
      />

      <div>
        <p class="smallBlueText">
          <em class="pi pi-info" />{{ $t("datos.textos.camposObligatorios") }}
        </p>
      </div>

      <div class="grid">
        <div class="col-12 md:col-6">
          <p class="blueText marginB5Px">{{ $t("datos.label.tipoEntidad") }}</p>
          <Dropdown
            v-model="datosAcreedorODeudor.tipoEntidad"
            :class="`input ${validation.entity === false && 'p-invalid'}`"
            :options="entidades"
            optionLabel="tipo"
            optionValue="key"
            :placeholder="$t('datos.placeholders.seleccionEntidad')"
          />
          <small v-if="validation.entity === false" class="p-invalid">{{
            $t("datos.messages.error.campoIncorrecto")
          }}</small>
        </div>
        <div class="col-12 md:col-6">
          <div class="box">
            <div class="p-inputgroup ajusteNoP">
              <InputConsulta
                v-if="isInputConsultaVisible"
                tipo="input"
                :tipoEntidad="datosAcreedorODeudor.tipoEntidad"
                v-bind:entidad="datosAcreedorODeudor"
                @informa:address="onInformaAddress($event)"
              />
            </div>
          </div>
        </div>

        <div v-if="isCnaeVisible" class="col-6 md:col-6 col-offset-3">
          <div class="box">
            <p class="blueText marginB5Px">
              {{ $t("datos.label.sectorActividad") }}{{ isDebtor ? "" : "*" }}
            </p>
            <Dropdown
              v-model="datosAcreedorODeudor.sectorActividad"
              :class="`input ${validation.sectorCnae === false && 'p-invalid'}`"
              :options="sectores"
              optionLabel="text"
              optionValue="value"
              :placeholder="$t('datos.placeholders.seleccionar')"
              @change="onSectorCnaeChange"
            />
            <small v-if="validation.sectorCnae === false" class="p-invalid">{{
              $t("datos.messages.error.campoIncorrecto")
            }}</small>
          </div>
        </div>

        <div v-if="isCnaeVisible" class="col-6 md:col-6">
          <div class="box">
            <p class="blueText marginB5Px">
              {{ $t("datos.label.codigoActividad") }}{{ isDebtor ? "" : "*" }}
            </p>
            <Dropdown
              v-model="datosAcreedorODeudor.codigoActividad"
              :class="`input ${validation.codigoCnae === false && 'p-invalid'}`"
              :options="codigosSectorSelected"
              optionLabel="text"
              optionValue="value"
              :placeholder="$t('datos.placeholders.seleccionar')"
            />
            <small v-if="validation.codigoCnae === false" class="p-invalid">{{
              $t("datos.messages.error.campoIncorrecto")
            }}</small>
          </div>
        </div>

        <div
          class="col-12 md:col-6 align-items-start"
          v-if="datosAcreedorODeudor.tipoEntidad !== entidades[2].key"
        >
          <p class="blueText marginB5Px">{{ $t("datos.label.nombre") }}</p>
          <InputText
            v-model="datosAcreedorODeudor.nombre"
            :class="`input ${validation.name === false && 'p-invalid'}`"
            type="text"
            :placeholder="$t('datos.placeholders.nombre')"
          />
          <small v-if="validation.name === false" class="p-invalid">{{
            $t("datos.messages.error.campoIncorrecto")
          }}</small>
        </div>
        <div
          class="col-12 md:col-6"
          v-if="datosAcreedorODeudor.tipoEntidad !== entidades[2].key"
        >
          <p class="blueText marginB5Px">{{ $t("datos.label.apellidos") }}</p>
          <InputText
            v-model="datosAcreedorODeudor.apellidos"
            :class="`input ${validation.lastName === false && 'p-invalid'}`"
            type="text"
            :placeholder="$t('datos.placeholders.apellidos')"
          />
          <small v-if="validation.lastName === false" class="p-invalid">{{
            $t("datos.messages.error.campoIncorrecto")
          }}</small>
        </div>

        <div
          class="col-12 md:col-6 align-items-start"
          v-if="datosAcreedorODeudor.tipoEntidad === entidades[2].key"
        >
          <p class="blueText marginB5Px">{{ $t("datos.label.razonSocial") }}</p>
          <InputText
            v-model="datosAcreedorODeudor.razonSocial"
            :class="`input ${validation.razonSocial === false && 'p-invalid'}`"
            type="text"
            :placeholder="$t('datos.placeholders.razonSocial')"
          />
          <small v-if="validation.razonSocial === false" class="p-invalid">{{
            $t("datos.messages.error.campoIncorrecto")
          }}</small>
        </div>

        <div
          class="col-12 md:col-6"
          v-if="datosAcreedorODeudor.tipoEntidad === entidades[2].key"
        >
          <div class="box">
            <p class="blueText marginB5Px">
              {{ $t("datos.label.tipoSociedad") }}
            </p>
            <Dropdown
              :disabled="true"
              v-model="datosAcreedorODeudor.tipoSociedad"
              class="input"
              :options="sociedades"
              optionLabel="text"
              optionValue="value"
              :placeholder="$t('datos.placeholders.tipoSociedad')"
            />
          </div>
        </div>

        <div class="col-12 md:col-4">
          <p class="blueText marginB5Px">{{ $t("datos.label.nif") }}</p>
          <InputText
            v-model="datosAcreedorODeudor.idLegal"
            @input="
              datosAcreedorODeudor.idLegal =
                datosAcreedorODeudor.idLegal.toUpperCase()
            "
            v-on:keyup="calculaTipoSociedad"
            :class="`input ${validation.idLegal === false && 'p-invalid'}`"
            type="text"
            :placeholder="$t('datos.placeholders.nif')"
          />
          <small v-if="validation.idLegal === false" class="p-invalid">{{
            $t("datos.messages.error.campoIncorrecto")
          }}</small>
        </div>
        <div class="col-12 md:col-4">
          <p class="blueText marginB5Px">{{ $t("datos.label.telefono") }}</p>
          <InputText
            v-model="datosAcreedorODeudor.telefono"
            :class="`input ${validation.telephone === false && 'p-invalid'}`"
            type="text"
            :placeholder="$t('datos.placeholders.telefono')"
          />
          <small v-if="validation.telephone === false" class="p-invalid">{{
            $t("datos.messages.error.campoIncorrecto")
          }}</small>
        </div>
        <div class="col-12 md:col-4">
          <p class="blueText marginB5Px">{{ $t("datos.label.email") }}</p>
          <InputText
            v-model="datosAcreedorODeudor.email"
            :class="`input ${validation.email === false && 'p-invalid'}`"
            type="email"
            :placeholder="$t('datos.placeholders.email')"
          />
          <small v-if="validation.email === false" class="p-invalid">{{
            $t("datos.messages.error.campoIncorrecto")
          }}</small>
        </div>
        <DireccionIcired
          ref="direccionComponent"
          :disabled="!datosAcreedorODeudor.tipoEntidad"
          :required="isDebtor"
        />
      </div>
    </div>
    <Dialog
      :visible.sync="displayModalFaltaInformacion"
      :modal="true"
      :contentStyle="{ overflow: 'visible' }"
      :closable="false"
    >
      <template #header>
        <span>
          {{ $t("datos.header.faltaInformacion") }}
        </span>
      </template>
      <div class="grid paddingLR">
        <div class="col-12">
          {{ $t("datos.textos.faltaInformacion") }}
        </div>
      </div>
      <template #footer>
        <div class="center">
          <Button
            :label="$t('common.buttons.accept')"
            icon="pi pi-check"
            @click="redirigirAlProfile()"
            autofocus
          />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>

import validations from "@/utils/validations.js";
import InputConsulta from "./Utils/InputConsulta";
import {
  GET_CNAE_LIST,
  GET_CNAE_LIST_BY_SECTOR,
  GET_LISTADO_TIPOS_SOCIEDAD,
} from "@/graphQLQueries/OtrosQueries/";
import { GET_USUARIO_BY_UUID } from "@/graphQLQueries/UsuarioQueries";
import { MAPPING_ID_LEGAL_TIPO_SOCIEDAD, CODIGOS_PROMOCIONALES } from "@/resources/constants";
import RoutesMixin from "@/utils/routes";
import MessagesMixin from "@/utils/messages";
import Errors from "@/components/utilidades/Errors.vue";
import DireccionIcired from "@/components/portal-cliente/Utils/DireccionIcired";
import GeneradorDNI from "@/service/GeneradorDNI";
import { PROVINCIAS} from "@/resources/cti";
const generadorDNI = new GeneradorDNI();


export default {
  name: "datosAcreedorODeudor",
  mixins: [RoutesMixin, MessagesMixin],
  props: {
    isDebtor: Boolean,
    actOnOwnName: Boolean,
    creditorOrDebtorData: {
      type: Object,
      required: true,
    },
    defaultLanguage: {
      type: Object,
      required: true,
    },
    paid: {
      type: Boolean,
      required: true,
    },
    entidades: Array,
  },
  components: {
    InputConsulta,
    Errors: Errors,
    DireccionIcired,
  },
  data() {
    return {
      errors: [],
      displayModalFaltaInformacion: false,
      language: this.defaultLanguage,
      isPaid: this.paid,
      sectores: [],
      codigosSectorSelected: [],
      sociedades: [],
      datosAcreedorODeudor: this.creditorOrDebtorData,
      autocomplete: false,
      actOwnName: false,
      userIdLegalBBDD: "",
      loadingCTIAddressNormalization: false,
      validation: {
        entity: true,
        name: true,
        lastName: true,
        idLegal: true,
        telephone: true,
        email: true,
        sectorCnae: true,
        codigoCnae: true,
        postalCode: true,
        actOnOwnName: true,
        actOnThirdPerson: true,
        razonSocial: true,
      },
      currentUserData: {},
      promotorEinforma: CODIGOS_PROMOCIONALES.EINFORMA,
      local:false
    };
  },
  mounted() {
    this.retrieveUserIDLegal();
  },
  created() {
    if (window.location.href.includes("localhost") ){
      this.local=true;
    }
  },
  methods: {
    onSectorCnaeChange(event) {
      const sector = event.value;
      this.retrieveCnaesBySector(sector);
    },
    hasFormErrors() {
      return !(
        this.validation.name &&
        this.validation.razonSocial &&
        this.validation.lastName &&
        this.validation.idLegal &&
        this.validation.telephone &&
        this.validation.email &&
        this.validation.entity &&
        this.validation.actOnOwnName &&
        this.validation.actOnThirdPerson &&
        this.validation.sectorCnae &&
        this.validation.codigoCnae &&
        this.$refs.direccionComponent.valid()
      );
    },
    validateForm() {
      this.errors = [];
      this.validateNif();
      this.validatePhone();
      this.validateName();
      this.validateRazonSocial();
      this.validateLastName();
      this.validateMail();
      this.validateEntityType();
      if (!this.$store.state.esGranCliente) {
        this.validateRespresentation();
      }
      this.validateSectorActividadCNAE();
      this.validateCodigoCNAE();
      this.$refs.direccionComponent.validate();
    },
    calculaTipoSociedad(e) {
      if (e.target.value) {
        var sociedad_value =
          MAPPING_ID_LEGAL_TIPO_SOCIEDAD[
            e.target.value.charAt(0).toUpperCase()
          ];
        if (sociedad_value) {
          this.datosAcreedorODeudor.tipoSociedad = sociedad_value;
          return;
        }
      }
      this.datosAcreedorODeudor.tipoSociedad = null;
    },
    searchCurrentUserData(uuid) {
      this.$apollo
        .query({
          query: GET_USUARIO_BY_UUID,
          variables: {
            uuidUsuario: uuid,
            idioma: this.$i18n.locale,
          },
          fetchPolicy: "no-cache",
        })
        .then(({data}) => {
          this.currentUserData = this.fromUserByUuidResponseToUser(
            data.getUsuarioUuid
          );
          this.updateCreditorOrDebtorData();
        })
        .catch(() => {
          this.setMessages(
            "error",
            this.$t("datos.messages.error.errorGenerico"),
            3000
          );
        });
    },
    fromUserByUuidResponseToUser(userByUuidResponse) {
      const direccion = userByUuidResponse.cliente.contactosActivos.direccion
        ? userByUuidResponse.cliente.contactosActivos.direccion.valor
        : null;

      return {
        nombre: userByUuidResponse.nombre,
        apellidos: userByUuidResponse.apellidos,
        idLegal: userByUuidResponse.idLegal,
        telefono: userByUuidResponse.contactosActivos.telefono
          ? userByUuidResponse.contactosActivos.telefono.valor.telefono
          : null,
        email: userByUuidResponse.contactosActivos.email.valor.email,
        pais: "ES",
        tipo: userByUuidResponse.tipo,
        cnae: userByUuidResponse.cnae,
        provincia: direccion ? direccion.provincia : null,
        localidad: direccion ? direccion.localidad : null,
        codigoPostal: direccion ? direccion.codigoPostal : null,
        tipoDireccion: direccion ? direccion.tipoDireccion : null,
        direccion: direccion ? direccion.direccion : null,
      };
    },
    updateCreditorOrDebtorData() {
      this.datosAcreedorODeudor.nombre = this.currentUserData.nombre;
      this.datosAcreedorODeudor.apellidos = this.currentUserData.apellidos;
      this.datosAcreedorODeudor.idLegal = this.currentUserData.idLegal;
      this.datosAcreedorODeudor.telefono = this.currentUserData.telefono;
      this.datosAcreedorODeudor.email = this.currentUserData.email;
      this.datosAcreedorODeudor.pais = this.currentUserData.pais;
      this.datosAcreedorODeudor.codigoActividad = this.currentUserData.cnae;
      this.datosAcreedorODeudor.tipoEntidad = this.entidades.find(
        (entidad) => this.currentUserData.tipo === entidad.key
      );

      this.$refs.direccionComponent.setData({
        provincia: this.currentUserData.provincia,
        localidad: this.currentUserData.localidad,
        codigoPostal: this.currentUserData.codigoPostal,
        tipoDireccion: this.currentUserData.tipoVia,
        direccion: this.currentUserData.direccion,
      });
    },
    retrieveUserIDLegal() {
      this.$apollo
        .query({
          query: GET_USUARIO_BY_UUID,
          variables: {
            uuidUsuario: this.$store.state.profile.uuid,
            idioma: this.$i18n.locale,
          },
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (
            this.$store.state.codigoPromotor != this.promotorEinforma &&
            ((data.getUsuarioUuid.genero !== "company" &&
              !data.getUsuarioUuid.apellidos) ||
              !data.getUsuarioUuid.nombre ||
              !data.getUsuarioUuid.idLegal ||
              !validations.validateNif(data.getUsuarioUuid.idLegal) ||
              !data.getUsuarioUuid.cliente.contactosActivos ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .tipoDireccion ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .direccion ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .localidad ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .provincia ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .pais ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .codigoPostal)
          ) {
            this.displayModalFaltaInformacion = true;
          }
          this.userIdLegalBBDD = data.getUsuarioUuid.idLegal;
        })
        .catch(() => {
          this.setMessages(
            "error",
            this.$t("datos.messages.error.errorGenerico"),
            3000
          );
        });
    },
    retrieveCnaes() {
      this.$apollo
        .query({
          query: GET_CNAE_LIST,
          variables: {
            idioma: this.language.language,
          },
        })
        .then((data) => {
          this.sectores = data.data.listadoTipoCnaesSectores.map((e) => {
            return {
              text: e.sector + "-" + e.literalTipoCnae.valor,
              value: e.sector,
            };
          });
        })
        .catch(() => {
          this.setMessages(
            "error",
            this.$t("datos.messages.error.errorGenerico"),
            3000
          );
        });
    },
    retrieveCnaesBySector(sector) {
      this.$apollo
        .query({
          query: GET_CNAE_LIST_BY_SECTOR,
          variables: {
            sector: sector,
            idioma: this.language.language,
          },
        })
        .then((data) => {
          this.codigosSectorSelected = data.data.listadoTipoCnaesPorSector
            .filter((tc) => tc.codigo != sector)
            .map((e) => {
              return {
                text: e.codigo + "-" + e.literalTipoCnae.valor,
                value: e.codigo,
              };
            });
        })
        .catch((error) => {
          console.error(error);
          this.setMessages(
            "error",
            this.$t("datos.messages.error.errorGenerico"),
            3000
          );
        });
    },
    retrieveSociedades() {
      this.$apollo
        .query({
          query: GET_LISTADO_TIPOS_SOCIEDAD,
          variables: {
            idioma: this.language.language,
          },
        })
        .then((data) => {
          this.sociedades = data.data.listadoTiposSociedad.map((e) => {
            return { text: e.valor, value: e.clave };
          });
        })
        .catch(() => {
          this.setMessages(
            "error",
            this.$t("datos.messages.error.errorGenerico"),
            3000
          );
        });
    },
    validateNif() {
      var cif = this.datosAcreedorODeudor.idLegal
        ? this.datosAcreedorODeudor.idLegal.toUpperCase()
        : "";
      if (!validations.validateNifOrCif(cif)) {
        this.$set(this.validation, "idLegal", false);
        return;
      }
      //Validar que el cif corresponde a empresa o no en funcion del tipoEntidad
      if ((this.datosAcreedorODeudor.tipoEntidad == this.entidades[2].key)) {
        validations.isValidCif(cif)
          ? this.$set(this.validation, "idLegal", true)
          : this.$set(this.validation, "idLegal", false);
      } else {
        validations.isValidCif(cif)
          ? this.$set(this.validation, "idLegal", false)
          : this.$set(this.validation, "idLegal", true);
      }
    },
    validateSectorActividadCNAE() {
      if (this.isCnaeVisible && !this.isDebtor)
        this.$set(
          this.validation,
          "sectorCnae",
          this.datosAcreedorODeudor.sectorActividad !== null &&
            this.datosAcreedorODeudor.sectorActividad !== ""
        );
      else this.$set(this.validation, "sectorCnae", true);
    },
    validateCodigoCNAE() {
      if (this.isCnaeVisible && !this.isDebtor)
        this.$set(
          this.validation,
          "codigoCnae",
          this.datosAcreedorODeudor.codigoActividad !== null &&
            this.datosAcreedorODeudor.codigoActividad !== ""
        );
      else this.$set(this.validation, "codigoCnae", true);
    },
    validatePhone() {
      if (
        !this.datosAcreedorODeudor.telefono ||
        this.datosAcreedorODeudor.telefono == ""
      )
        this.$set(this.validation, "telephone", true);
      else
        validations.validatePhone(this.datosAcreedorODeudor.telefono)
          ? this.$set(this.validation, "telephone", true)
          : this.$set(this.validation, "telephone", false);
    },
    validateName() {
      if (this.datosAcreedorODeudor.tipoEntidad == this.entidades[2].key) {
        this.$set(this.validation, "name", true);
      } else {
        this.datosAcreedorODeudor.nombre
          ? this.$set(this.validation, "name", true)
          : this.$set(this.validation, "name", false);
      }
    },
    validateRazonSocial() {
      if (this.datosAcreedorODeudor.tipoEntidad !== this.entidades[2].key) {
        this.$set(this.validation, "razonSocial", true);
      } else {
        this.datosAcreedorODeudor.razonSocial
          ? this.$set(this.validation, "razonSocial", true)
          : this.$set(this.validation, "razonSocial", false);
      }
    },
    validateLastName() {
      if (this.datosAcreedorODeudor.tipoEntidad == this.entidades[2].key) {
        this.$set(this.validation, "lastName", true);
      } else {
        this.datosAcreedorODeudor.apellidos
          ? this.$set(this.validation, "lastName", true)
          : this.$set(this.validation, "lastName", false);
      }
    },
    validateMail() {
      if (
        !this.datosAcreedorODeudor.email ||
        this.datosAcreedorODeudor.email == ""
      )
        this.$set(this.validation, "email", true);
      else
        validations.validateMail(this.datosAcreedorODeudor.email)
          ? this.$set(this.validation, "email", true)
          : this.$set(this.validation, "email", false);
    },
    validateEntityType() {
      this.datosAcreedorODeudor.tipoEntidad
        ? this.$set(this.validation, "entity", true)
        : this.$set(this.validation, "entity", false);
    },
    validateRespresentation() {
      this.validateActOwnName(
        this.datosAcreedorODeudor.idLegal,
        this.userIdLegalBBDD
      );
      this.validateActOnThirdPerson(
        this.datosAcreedorODeudor.idLegal,
        this.userIdLegalBBDD
      );
    },
    validateActOwnName(idLegalAcreedor, idLegalUsuario) {
      if (this.actOnOwnName) {
        if (idLegalAcreedor === idLegalUsuario) {
          this.$set(this.validation, "actOnOwnName", true);
        } else {
          this.errors.push(
            this.$i18n.t("datos.messages.error.actuaEnPropioNombre")
          );
          this.$set(this.validation, "actOnOwnName", false);
        }
      } else {
        this.$set(this.validation, "actOnOwnName", true);
      }
    },
    validateActOnThirdPerson(idLegalAcreedor, idLegalUsuario) {
      if (!this.actOnOwnName) {
        if (idLegalAcreedor != idLegalUsuario) {
          this.$set(this.validation, "actOnThirdPerson", true);
        } else {
          this.errors.push(
            this.$i18n.t("datos.messages.error.actuaEnTerceraPersona")
          );
          this.$set(this.validation, "actOnThirdPerson", false);
        }
      } else {
        this.$set(this.validation, "actOnThirdPerson", true);
      }
    },
    checkDisable(comprobarTipoEntidad) {
      if (this.isDebtor) return false;
      //Activo formulario
      else {
        if (comprobarTipoEntidad) return this.isPaid || !this.filledTipoEntidad;
        else return this.isPaid;
      }
    },
    redirigirAlProfile() {
      this.goToProfile();
    },
    onInformaAddress(address) {
      this.$refs.direccionComponent.setData({
        tipoDireccion: address.typeOfRoad,
        direccion: address.address,
        codigoPostal: address.postalCode
      });
    },
    updateAddress() {
      const direccionData = this.$refs.direccionComponent.getData();

      if (direccionData) {
        this.currentUserData.provincia = direccionData.provincia;
        this.currentUserData.localidad = direccionData.localidad;
        this.currentUserData.codigoPostal = direccionData.codigoPostal;
        this.currentUserData.tipoDireccion = direccionData.tipoDireccion;
        this.currentUserData.direccion = direccionData.direccion;
        this.currentUserData.pais = direccionData.pais;
      }

      return direccionData;
    },
    setAddress(address) {
      this.$refs.direccionComponent.setData({tipoDireccion: address.tipoVia, direccion: address.direccion, codigoPostal: address.codigoPostal});      
      this.updateAddress({
        province: this.currentUserData.provincia,
        location: this.currentUserData.localidad,
        postalCode: this.currentUserData.codigoPostal,
        typeOfRoad: this.currentUserData.tipoVia,
        address: this.currentUserData.direccion,
      });
    },
    radomUser(){
      generadorDNI.radomUser().then((response) => {
        const radomUser = response.data[0];
        this.datosAcreedorODeudor.nombre = radomUser.name;
        this.datosAcreedorODeudor.apellidos= radomUser.surname + " " + radomUser.surnname2;
        this.datosAcreedorODeudor.idLegal = radomUser.nif;
        this.datosAcreedorODeudor.telefono = radomUser.phonenumber;
        this.datosAcreedorODeudor.email = radomUser.email;
        
        this.$refs.direccionComponent.setData({
          province: PROVINCIAS.find((p) => p.codProvincia === radomUser.province_inecode).codISO,
          location: radomUser.municipality,
          postalCode: radomUser.municipality_inecode,
          typeOfRoad: 'C',
          address: radomUser.address + " " + radomUser.address_number,
        });
        this.datosAcreedorODeudor.tipoSociedad="deudorParticular";
            console.log(response.data[0]);});
    }
  },
  watch: {
    entityType(newValue) {
      if (newValue !== this.entidades[0].tipo && this.sectores.length == 0) {
        this.retrieveCnaes();
        this.retrieveSociedades();
      }
    },
    creditorOrDebtorData(newValue) {
      this.datosAcreedorODeudor = newValue;
    },
    language(newValue) {
      this.defaultLanguage = newValue;
    },
    defaultCountries(newValue) {
      this.paises = newValue;
    },
    paid(newValue) {
      this.isPaid = newValue;
    },
    actOnOwnName(newValue) {
      if (newValue && !this.isDebtor) {
        if (Object.keys(this.currentUserData).length == 0) {
          //Si el borrador (currentDraft) viene con datos no vamos a buscarlo a bbdd
          if (!this.datosAcreedorODeudor.idLegal)
            this.searchCurrentUserData(this.$store.state.profile.uuid);
        } else {
          this.updateCreditorOrDebtorData();
        }
      }
      this.actOnOwnName = newValue;
    },
    sectorActividad(newValue, oldValue) {
      if (!oldValue && newValue) this.retrieveCnaesBySector(newValue);
    },
    codigoActividad() {
      this.retrieveCnaesBySector(this.datosAcreedorODeudor.sectorActividad);
    },
    datosAcreedorODeudor() {
      this.setAddress({
        provincia: this.datosAcreedorODeudor.provincia,
        localidad: this.datosAcreedorODeudor.localidad,
        codigoPostal: this.datosAcreedorODeudor.codigoPostal,
        tipoVia: this.datosAcreedorODeudor.tipoVia,
        direccion: this.datosAcreedorODeudor.direccion,
      });
    },
  },
  computed: {
    legalId() {
      return this.datosAcreedorODeudor.idLegal;
    },
    telephone() {
      return this.datosAcreedorODeudor.telefono;
    },
    email() {
      return this.datosAcreedorODeudor.email;
    },
    name() {
      return this.datosAcreedorODeudor.nombre;
    },
    lastName() {
      return this.datosAcreedorODeudor.apellidos;
    },
    entityType() {
      return this.datosAcreedorODeudor.tipoEntidad;
    },
    sectorActividad() {
      return this.datosAcreedorODeudor.sectorActividad;
    },
    codigoActividad() {
      return this.datosAcreedorODeudor.codigoActividad;
    },
    filledTipoEntidad() {
      return (
        this.entidades.find((obj) => {
          return obj.key === this.datosAcreedorODeudor.tipoEntidad;
        }) !== undefined
      );
    },
    isInputConsultaVisible() {
      const tiposEntidadVisibles = [this.entidades[2].key];

      return tiposEntidadVisibles.includes(
        this.datosAcreedorODeudor.tipoEntidad
      );
    },
    isCnaeVisible() {
      if (this.isDebtor)
        return this.datosAcreedorODeudor.tipoEntidad === this.entidades[2].key;

      return (
        this.datosAcreedorODeudor.tipoEntidad === this.entidades[1].key ||
        this.datosAcreedorODeudor.tipoEntidad === this.entidades[2].key
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.titlesContainer {
  padding-bottom: 1.25em !important;
}
.ajusteNoP {
  margin-top: 1cm;
}
input {
  height: 3rem !important;
}
.btn-flotante {
	font-size: 16px; /* Cambiar el tamaño de la tipografia */
	text-transform: uppercase; /* Texto en mayusculas */
	font-weight: bold; /* Fuente en negrita o bold */
	color: #ffffff; /* Color del texto */
	border-radius: 5px; /* Borde del boton */
	letter-spacing: 2px; /* Espacio entre letras */
	background-color: #E91E63; /* Color de fondo */
	padding: 18px 30px; /* Relleno del boton */
	position: fixed;
	bottom: 40px;
	right: 40px;
	transition: all 300ms ease 0ms;
	box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
	z-index: 99;
}
.btn-flotante:hover {
	background-color: #2c2fa5; /* Color de fondo al pasar el cursor */
	box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.3);
	transform: translateY(-7px);
}
</style>
